// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"28cb7b37","900":"f8d958b3"}[chunkId] + ".chunk.js";
};